import { LinkToProductItem } from '../../../../components/Links/LinkToProductItem'
import AddToBoard from '../../../../components/AddToBoard'

import React from 'react'
import { formatMoney } from '@ztechapps/common.utils'
import { DiscountLabel, PricePerUom, ProductSize1Image } from '@ztechapps/product.webui'
import { ButtonGroup, Card, Row, Stack } from 'react-bootstrap'
import { HorizontalStack, ShowIf } from '@ztechapps/webui.util'
import { AddToCartButton } from '../../../../components/Product/AddToCartButton'
import type { Product } from '@ztechapps/common.contract'

export const ProductGridLayout = (product: Product) => {
  const { originalPrice, discountPercentage } = product
  return (
    <Card className="bg-light">
      <Row className="g-2">
        <div className="col-xl-3 col-lg-4 col-md-12 col-12">
          <LinkToProductItem _id={product?._id} productCode={product?.code}>
            <ProductSize1Image
              url={product?.coverImage}
              name={product?.name}
              className="img-fluid w-100"
              showLoading={true}
            />
          </LinkToProductItem>
        </div>
        <div className="col-xl-6 col-lg-5 col-md-7 col-sm-7">
          <Card.Body>
            <Stack gap={5}>
              <div>
                <LinkToProductItem className="fw-bold" _id={product?._id} productCode={product?.code}>
                  [{product?.code}] - {product?.name}
                </LinkToProductItem>
              </div>

              <div>
                <ButtonGroup>
                  <AddToCartButton product={product} />
                  <AddToBoard product={product} />
                </ButtonGroup>
              </div>
            </Stack>
          </Card.Body>
        </div>
        <aside className="col-xl-3 col-lg-3 col-md-5 col-sm-5">
          <Card.Body className="bg-secondary-subtle">
            <Stack className="  text-end">
              <div>
                <PricePerUom price={product?.price} uom={product?.orderUom?.name} className="h4 m-0 text-muted" />
              </div>
              <div>
                <HorizontalStack className="justify-content-end">
                  <ShowIf condition={discountPercentage > 0}>
                    <span>
                      <span className="text-decoration-line-through text-muted">{formatMoney(originalPrice)}</span>
                    </span>
                  </ShowIf>
                </HorizontalStack>
              </div>
              <div>
                <DiscountLabel discountPercentage={discountPercentage} />
              </div>
            </Stack>
          </Card.Body>
        </aside>
      </Row>
    </Card>
  )
}
